import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectedRentalPlanSelector as selectedRentalPlan } from 'ggApp/modules/rentalPlan/selectors';

import PriceSuffix from './PriceSuffix';

export default connect(
    createStructuredSelector({
        selectedRentalPlan,
    }),
)(PriceSuffix);
